module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter Introduction"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_84071-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xi"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xi"
    }
  }, [_c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_84071-00001"
    }
  }, [_c('h1', [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84071-00001"
    }
  }, [_c('i', [_vm._v("1982, Janine")]), _vm._v(", Alasdair Gray’s second novel, is a text that resists interpretation as completely as its predecessor, "), _c('i', [_vm._v("Lanark")]), _vm._v(", invites it. Not only is this a novel that stands in a fictional dock, accused of the most experimental of imaginative crimes, it is also a book that positively resists the reader. Do not, I beg of you, pick it up lightly; do not, I urge you, be deceived by its come-hither appearance and easy way with words, into believing that 1982, "), _c('i', [_vm._v("Janine")]), _vm._v(" will let you go before you have been shaken up and rubbed down. Trust me, you will leave go at the end sore and nauseous, in need of balm and a vomit.")])]), _c('p', {
    attrs: {
      "id": "rw-p_84071-00002"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xi"
    }
  }, [_vm._v("Why should we trouble ourselves with difficult books? Why should we not slurp fictional mush and be spoon-fed undemanding narratives? For the simple reason that if literature doesn’t have a capacity for awkwardness, then it cannot convey anything of the unreality of what it is to be in this world. Alasdair Gray himself has invoked Joyce’s view that ‘great art should not move us … only improper arts (propaganda and pornography) move us, but true art arrests us in the face of eternal beauty, or truth, or that.’ something like that.’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-0",
      "id": "num-footnote-1-0-back"
    }
  }, [_vm._v("1")]), _vm._v(" 1982, "), _c('i', [_vm._v("Janine")]), _vm._v(", with its peculiar mixture of propaganda, pornography and, if not exactly eternal beauty or truth, at least something like that, is thus a stop-go experience. The reader will get up a fair speed over a few pages, only to be arrested by one of Gray’s typographical exercises, meta-fictional games, narrative time loops, or simply a sticky patch of glutinous – and yet lovely – prose.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84071-00003"
    }
  }, [_vm._v("So rebarbative is this book, that even between its own covers are premonitory warnings addressed directly to me: ‘Why am I diluting an enjoyable wicked fantasy with this sort of crap?’ asks our protagonist, Jock McLeish, as he digresses from describing Janine, his mind-spun succubus, to a homespun version of Berkeley’s Argument from Illusion, before analogising further ‘like a publisher attaching a brainy little essay by a French critic to "), _c('i', [_vm._v("The Story of O")]), _vm._v(" to make the porn-eaters feel they are in first-class intellectual company.’ And while "), _c('i', [_vm._v("1982, Janine")]), _vm._v(" is not quite a work of pornography, I am surely worse than a French critic; namely, an English writer.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84071-00005"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xii"
    }
  }, [_vm._v("But to introduce "), _c('i', [_vm._v("1982, Janine")]), _vm._v(" it isn’t enough to merely say ‘Novel this is Reader, Reader this is Novel’, and then expect the two of you to forge a quick and easy intimacy Gray has said that this is his favourite among his own books, and moreover that ‘I made a novel I had not foreseen.’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-2-1",
      "id": "num-footnote-2-1-back"
    }
  }, [_vm._v("2")]), _vm._v(" Perhaps it is this very quality of a text, worked up from a central conceit as a form of fictional bricolage, that makes it so disorienting. So, we are introduced to Jock McLeish, an alcoholic installer of security systems, who lies tippling whisky on his bed, in his room, in a family hotel somewhere in the lowlands of Scotland. We then accompany him as he attempts to stave off the truth about himself by indulging in a series of pornographic playlets; preposterous productions for which he himself is director, screenwriter, casting director and lighting technician. When McLeish’s Janine ‘hears two unfastened studs of her skirt click with each step she takes.’ she is not alone. ‘“That’s a sexy sound,” the voice says, and giggles.’ The voice is a Russian doll, Gray inside of McLeish, and you, dear reader, inside of Gray himself. You will hear those two unfastened studs click again and again throughout these pages, and each time they will act as a tocsin, reawakening you to the recursiveness of McLeish’s fantasies, at once playful and deadly serious, both mucky and yet oddly jocose.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84071-00006"
    }
  }, [_vm._v("What are we to make of the sexual imaginings in "), _c('i', [_vm._v("1982,")]), _vm._v(" "), _c('i', [_vm._v("Janine?")]), _vm._v(" (And make of them something we must, for they constitute too much of the text to be dismissed as mere filler.) Gray himself has said ‘… this particular story started discoursing of improper things: sex fantasies I had meant to die without letting anybody know happen in this head sometimes …’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-2",
      "id": "num-footnote-3-2-back"
    }
  }, [_vm._v("3")])]), _vm._v(" Can he be serious? After all, it’s one thing to allow such ‘imaginings’ to spill on to the pages of a private journal, altogether another to labour over them and then publish. Such committed fans of the novel as Jonathan Coe, have felt moved to dismiss them: ‘I have always found the sex in "), _c('i', [_vm._v("1982, Janine")]), _vm._v(", incidentally, among the most boring ever committed to paper.’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-3",
      "id": "num-footnote-4-3-back"
    }
  }, [_vm._v("4")])]), _vm._v(" An opinion he then qualifies: ‘It’s only the fantasy sex that is boring. The “real” sex, the sex that is supposed at some point to have taken place outside of Jock McLeish’s head, is described with a plainness and honesty and lack of sensationalism that makes it deeply sympathetic and compelling, if entirely unerotic.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84071-00008"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xiii"
    }
  }, [_vm._v("I cannot concur. While all pornographic prose suffers from too much – and too well lubricated – a movement, towards one inescapable ending (they all came happily ever after), McLeish/Gray’s Sadean ‘imaginings’ have more than one obvious virtue. First they act as the primary means of repression, ensconced with Janine, Helga, Superb – and not forgetting Big Momma – our protagonist can evade the reality of his relations with Helen, Sontag and most especially Denny. Secondly, the ‘imaginings’ are at once baroque and highly contrived, acting as a projection of McLeish’s negative politics. The meticulously imagined scenes of violation and humiliation are compounded with corporate structures of sexual exploitation, culminating in the distinctly Burroughsian ‘Forensic Research Punishment and Sexual Gratification Syndicate’. Thirdly, despite McLeish’s avowed anti-Freudianism (‘I believe that under the surface we are very like how we appear above it, which is why so many surfaces last a lifetime without cracking’), the ‘imaginings’ serve to demonstrate that the boy’s sexual repression is father to the man’s sexual bullying. McLeish’s treatment at the hands of Hislop – his putative father – and his fixation on the famous image of Jane Russell in "), _c('i', [_vm._v("The Outlaw")]), _vm._v(" (and let us not forget that the real Russell was herself the erotic plaything of a deeply disturbed man), are festering fungi beneath the mulch of his conscious mind. In drunkenness, in despair, they swell with alarming alacrity.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xiii"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_84071-00010"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xiii"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_xiv"
    }
  }, [_vm._v("And lastly, while by no means certain that I myself am a closet sadomasochist, I find McLeish’s ‘imaginings’ a sufficient turn on. Sufficient, because shorn of their denim raiment and elaborate staging, these are really fantasies about the oedipal intensity of sex from the perspective of a motherless (in the sense of abandoned) boy McLeish’s dream women are – for the most part – fecund, as he eulogises it: ‘The sweetest line in the world was the profile of forgethername’s belly curving out suddenly from her navel and then down in a swooping line to oh, I can never go there again, never never never again. Entering there was such sweet "), _c('i', [_vm._v("homecoming")]), _vm._v(", I can never "), _c('i', [_vm._v("go home")]), _vm._v(" again.’ (My italics). And later in the novel, he more explicitly characterises the female body as ‘THE LANDSCAPE OF HOME’. Forced by Sontag to confess to a perversion, McLeish admits to being a paedophile – which he is not – purely because ‘I found it less frightening to tell a lie than admit to a woman that I had a mad passion for women.’")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xiv"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_84071-00011"
    }
  }, [_vm._v("Looked at this way the ‘imaginings’ are the purest of sexual fantasies, being concerned entirely with the natal and procre-ative character of copulation, the white worm of life–desire, which is condemned forever to swallow its own tail. It is surely not without accident (although the intent was doubtless unconscious), that while McLeish remains childless, his entire life is haunted by possibilities of pregnancy. Besides, to banish the ‘imaginings’ to the status of a boring aberration is to undermine the whole ground of Gray’s novel; the author himself was so preoccupied with the female crux that the boards of the first edition were decorated with a repeating pattern of Ys, alternately right-way-up and upside down. This was, of course, evocative of the ‘imagining’ wherein McLeish’s dream women were posed with their wrists tied above their heads. A reverie, the painful denouement of which – it’s resolution in querulous, querying cunnilingus – is indicated in the text by the reversal of the Ys.")])]), _c('p', {
    attrs: {
      "id": "rw-p_84071-00012"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xiv"
    }
  }, [_vm._v("This brings us, logically enough, to the typographical exercises in "), _c('i', [_vm._v("1982, Janine")]), _vm._v(". Gray, as perhaps the finest artist/writer of his generation, is always a conspicuous ‘maker’ of his own books, rather than merely an author. With this novel the use of enlarged and justified type for the beginning of chapters (which are indicated solely by numbers within the body copy), the employment of a rubric for the outside margins, and the chapter ")]), _c('a', {
    attrs: {
      "id": "pb-rw_xv"
    }
  }, [_vm._v("summaries in the table of contents, combine to give the text a biblical appearance. But this is standard for Gray, and I would argue just one of the methods he employs to both position his books as ur-texts – primary books from which others derive – and to resist modernity. As Angus Calder has remarked,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-5-4",
      "id": "num-footnote-5-4-back"
    }
  }, [_vm._v("5")]), _vm._v(" to label Gray’s various devices – typographical and other glosses – ‘postmodern’ is ridiculous. And A. L. Kennedy – acting as Gray’s proxy – writes of Sterne’s "), _c('i', [_vm._v("Tristram Shandy")]), _vm._v(": ‘The book is wilful, exuberant, bawdy, gleefully plagiarising, eccentric & humane. It delights in its fiction, freely acknowledging the conversation that joins author & reader & using every device that late 20"), _c('sup', [_vm._v("th")]), _vm._v("-century critics label "), _c('i', [_vm._v("post-modernist")]), _vm._v(".’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-5",
      "id": "num-footnote-6-5-back"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84071-00013"
    }
  }, [_vm._v("In fact, Gray’s word games are emphatically pre-modern. Rather than attempting to undermine the notion of objective truth by playing with the shattered fragments of the past, Gray shows us how our notions of reality are forced upon us by the relation in which they stand to one another (a technique he shares – albeit in a different form – with Borgés). Thus, the ‘invented’ plagiarisms, the bowdlerised jacket quotes, the typographical conundrums, and even the manner in which McLeish’s fantasies are many layered – all of these serve to impress upon the reader the emotional and philosophic truth of Gray’s fictions. In "), _c('i', [_vm._v("1982, Janine")]), _vm._v(", this reaches a climax in Chapter Eleven, ‘The Ministry of Voices’, where Jock McLeish’s descent into delirium is chronicled by no fewer than four distinct narrative voices occupying the page at once. Gray again: ‘On one margin the voice of his body complains of the feverish temperature he’s condemned to, while in the middle his deranged libido fantasises and alternates with his deranged conscience denouncing him for having such fantasies. On the other margin, in very small print, the voice of God tries to tell him something important, tell him he has missed the point of living in a voice he can hardly hear, because it is not thunderously denouncing …’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-6",
      "id": "num-footnote-7-6-back"
    }
  }, [_vm._v("7")])]), _vm._v(" For the reader this is, once more, hard work, not least because the shapes the type forms on the page seem to mirror the fantasies of invagination which plague McLeish. It is with something like relief that you gain the blank pages that follow, symbolising McLeish’s own sleep, and possibly the sleep of reason as well.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84071-00015"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xvi"
    }
  }, [_vm._v("The presence of God in Gray’s work – God reasonable, God magical, God immanent and transcendent – is another of the markers of the pre-rather than the postmodern. As Gray puts it, ‘God is one of the most popular characters in fiction.’ By which I think he means to say ‘in reality’. But if Gray’s sensibility in 1982, "), _c('i', [_vm._v("Janine")]), _vm._v(" is pre-modern, and his text is built up out of what De Quincey termed ‘involutes’ (those proto-Freudian compounds of memory and desire), yet the dateline title of the book is no accident.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xvi"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_84071-00016"
    }
  }, [_vm._v("Not only is the novel taking place in the mind of McLeish, on a bed, in a hotel, in a small lowlands Scottish town (or so we are led to believe), this is also emphatically 1982, a point at which Scotland could be said to have reached just one of its many nadirs. McLeish is created, by Gray, as an antithesis of himself: the honestly self-interested, almost Social-Darwinian right winger:‘… in Britain,’ McLeish soliloquises ‘almost everyone of my income group is Conservative, especially if their fathers were trade unionists. Not that I’ve entirely rejected the old man’s Marxist ideas. The notion that all politics is class warfare is clearly correct. Every intelligent Tory knows that politics is a matter of people with a lot of money combining to manage people with very little, though of course they must deny it in public to mislead the opposition.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84071-00017"
    }
  }, [_vm._v("In 1982 this is horribly salient, with 40,000 British workers losing their jobs weekly, unemployment well past the two million mark, the steel and coal industries on which Scots industry depends being decimated, while at the head of it all stands a Premier intent on abandoning the Neo-Keynesian, Butskellite consensus of the post-war period, by slashing a billion pounds of public expenditure. In the slough that came after the refusal of the limited devolution offered by James Callaghan’s Labour Government, the Scots nationalists (among whom, surprisingly, McLeish includes himself) are foundering in the river of rust which cinches the waist of Scotland (much in the manner that a leather belt cinches one of McLeish’s dream women).")])]), _c('p', {
    attrs: {
      "id": "rw-p_84071-00018"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xvi"
    }
  }, [_vm._v("Nevertheless, while McLeish’s Hobbesian credo provides ")]), _c('a', {
    attrs: {
      "id": "pb-rw_xvii"
    }
  }, [_vm._v("some of the pithiest and starkest observations in the novel, it is never wholly convincing. Gray has confessed that in creating a mirror image of himself, he has simply provided another self-portrait, and this rings true. By far the most credible portions of the book, are those that limn in – using the characters of McLeish’s father, and his friend ‘Old Red’, as well as the Edinburgh Festival interlude – the utopian socialist Scots nationalism for which Gray himself is well known. Such is the intensity of conviction, and the way in which the authorial voice lurking over McLeish’s shoulder addresses the ordinary reader, that this ‘socialist unrealism’ – if I may be permitted the coinage – is what carries the day. That, and a bellow of tortured identification with his own benighted fellow countrymen. As McLeish puts it: ‘The truth is we are a nation of arselickers, though we disguise it with surfaces: a surface of generous, openhanded manliness, a surface of dour practical integrity, a surface of futile maudlin defiance …’ It is these agonies of sad self-revulsion that elevate McLeish to the status of a personification of Scotland in 1982.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xvii"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_84071-00019"
    }
  }, [_vm._v("And if 1982, "), _c('i', [_vm._v("Janine")]), _vm._v(" is the-book-of-the-state-of-the-nation, it is also the book of the state of its author. It would be invidious to detail all the correspondences between McLeish’s life and experiences and those of his creator (aren’t all fictions forms of emotional autobiography?), but suffice to say, they are there. Gray hadn’t wanted to use an artist or a writer as his protagonist, but anyway, such models weren’t available to him for a long time. It may seem strange, writing now in the eye of a thriving – if stormy – renaissance in Scots letters, but Gray himself didn’t know more than one professional writer (Archie Hind) before the age of thirty-five. Placed in this context, the work and the life that went into the creation of this book – and Gray’s first novel "), _c('i', [_vm._v("Lanark")]), _vm._v(" – was curiously unprecedented. It is by no means overly ambitious for Gray to have given this book a biblical format, because for him – and for the generation of Scots writers who was to follow – it was indeed a foundational text.")])]), _c('p', {
    attrs: {
      "id": "rw-p_84071-00020"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xvii"
    }
  }, [_vm._v("So, tumultuous, inventive, heart-rending. Both pre– and postmodern. A conventional narrative gussied up as an experimental work of fiction, which is at the same time a deeply experimental work hiding a little novella in the pleats of its skirt. A ")]), _c('a', {
    attrs: {
      "id": "pb-rw_xviii"
    }
  }, [_vm._v("series of sadomasochistic fantasies, that reach their climax with the still, small voice of God. A landmark work for newly emergent Scots literature, and in my view one of the finest post-war novels in English. It is definitely one of the books I would choose to take to my desert island – and I already have. The name of the island is Britain.")])]), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_84071-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xviii"
    }
  }, [_c('p', {
    staticClass: "fp"
  })])]), _c('a', {
    attrs: {
      "id": "pb-rw_xviii"
    }
  }, [_c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_84071-00021"
    }
  }, [_vm._v("Alasdair Gray, your friend in the south salutes you.")]), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_84071-00002"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "rw-p_84071-00022"
    }
  }, [_vm._v("Will Self "), _c('br'), _vm._v("London 2002")])]), _c('div', {
    staticClass: "block footnotes"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xviii"
    }
  }), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xviii"
    }
  }, [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-0"
    }
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-0-back"
    }
  }, [_vm._v("1")]), _vm._v(" Public interview with Kathy Acker at the Institute of Contemporary Arts in London, 1986. Reprinted in "), _c('em', [_vm._v("Alasdair Gray: Critical Appreciations and a Bibliography")]), _vm._v(", ed. Phil Moores, The British Library, 2002. ")]), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-1-back"
    }
  }, [_vm._v("2")])]), _vm._v(" Ibid.")]), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-2-back"
    }
  }, [_vm._v("3")])]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-3-back"
    }
  }, [_vm._v("4")])]), _vm._v(" ‘1994 Janine’ in Moores (Ibid.)")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-4-back"
    }
  }, [_vm._v("5")])]), _vm._v(" ‘Politics, Scotland and Prefaces’ in Moores (Ibid.)")]), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-5-back"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('i', [_vm._v("The Book of Prefaces")]), _vm._v(", Bloomsbury, 2000.")]), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-6-back"
    }
  }, [_vm._v("7")])]), _vm._v(" Ibid.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60a2d605","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847674449_introduction.vue
// module id = 75
// module chunks = 0